var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar-group',{attrs:{"size":"35px"}},_vm._l((_vm.collaborators),function(item,index){return _c('b-avatar',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(item.name),expression:"item.name",modifiers:{"hover":true,"top":true}}],key:index,attrs:{"variant":"primary","text":item.userInitials,"src":item.avatar}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }